import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { RenaultCampaignGalleryImageDTO, RenaultCampaignTagDTO, RenaultCampaignGalleryImageByTagDTO } from '../models/renault-campaign-gallery-dto';

@Injectable({
  providedIn: 'root'
})

export class GalleryService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultGallery/";

  constructor(private http: HttpClient) { }

  // Image methods
  public getImage(id: string): Observable<RenaultCampaignGalleryImageDTO> {
    return this.http.get<RenaultCampaignGalleryImageDTO>(this.pathAPI + this.controller + 'Image/' + id);
  }

  public postImage(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'Image', data);
  }

  public putImage(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'Image/' + id, data);
  }

  public changeImageStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'Image/ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getImagesDataTable(data: any, tagId?: number): Observable<DataTablesResponse> {
    const url = tagId
      ? `${this.pathAPI}${this.controller}Image/GetDataTable?tagId=${tagId}`
      : `${this.pathAPI}${this.controller}Image/GetDataTable`;
    return this.http.post<DataTablesResponse>(url, data);
  }

  public getImagesByTags(tags: string[]): Observable<RenaultCampaignGalleryImageByTagDTO[]> {
    return this.http.post<RenaultCampaignGalleryImageByTagDTO[]>(this.pathAPI + this.controller + 'Image/GetByTags', tags);
  }

  // Tag methods
  public getTag(id: string): Observable<RenaultCampaignTagDTO> {
    return this.http.get<RenaultCampaignTagDTO>(this.pathAPI + this.controller + 'Tag/' + id);
  }

  public getAllTags(): Observable<RenaultCampaignTagDTO[]> {
    return this.http.get<RenaultCampaignTagDTO[]>(this.pathAPI + this.controller + 'Tag/GetAll');
  }

  public postTag(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'Tag', data);
  }

  public putTag(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'Tag/' + id, data);
  }

  public deleteTag(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'Tag/' + id);
  }

  public getTagsDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'Tag/GetDataTable', data);
  }
}
